<div class="auto-reply-section-content">
  <span class="mb-1 text-center"
    >Activate webhooks in order to have more options in setting up the answers (triggers, filters, conditions, NLP...)</span
  >
  <div class="auto-reply-section-content">
    <span
      ><i class="fas fa-info-circle"></i> Not sure how to make it work? Check out this
      <a href="https://forum.ideta.io/t/how-to-use-webhooks-in-auto-comment-tool/178" target="_blank">forum post! </a></span
    >

    <div class="select-action-container">
      <input
        type="text"
        class="edit-message-bloc-input"
        id="webhook_url"
        name="webhook_url"
        [(ngModel)]="webhook_url"
        #webhook_url_elmt="ngModel"
        placeholder="WEBHOOK URL..."
        (change)="setWebhookUrl(webhook_url_elmt.value)"
      />
      <button
        *ngIf="!spinning"
        class="custom-btn custom-btn-primary h-100"
        type="button"
        (click)="testWebhookUrl()"
        [disabled]="webhook_url.length === 0"
      >
        VALIDATE URL
      </button>
    </div>
    <div class="flex-grow-1 d-flex flex-column align-items-center justify-content-center mt-3" *ngIf="spinning">
      TESTING THE WEBHOOK URL...
      <app-tiny-bot-spinner></app-tiny-bot-spinner>
    </div>
    <div *ngIf="!spinning && !validWebhookUrl && testedWebhookUrl" class="mt-3 text-center info-text">
      <div><i class="fas fa-exclamation-circle text-warning"></i> This webhook url is not valid! Please try again with another url.</div>
      <div>
        You can build your webhook by following this
        <a href="https://forum.ideta.io/t/how-to-use-webhooks-in-auto-comment-tool/178" target="_blank">documentation </a>.
      </div>
    </div>
    <div *ngIf="!spinning && validWebhookUrl && testedWebhookUrl">
      <div class="mt-3 mb-5 text-center info-text">
        <div><span class="text-success mb-3 mr-2">✅ </span> This webhook url can be used!</div>
        <div>You can <span class="text-success">publish</span> your campaign or <span class="text-success">test it </span>below before!</div>
      </div>
      <div class="d-flex flex-column">
        <label class="auto-reply-section-content-label text-center" for="test_webhook_message">TEST YOUR WEBHOOK</label>
        <div><i class="fas fa-info-circle"></i> Send the message to your webhook (It will be treated as a message received on one of your posts)</div>
        <div class="select-action-container">
          <input
            type="text"
            class="edit-message-bloc-input"
            id="test_webhook_message"
            name="test_webhook_message"
            [(ngModel)]="test_webhook_message"
            #test_webhook_message_elmt="ngModel"
            placeholder="TYPE SOMETHING..."
            (change)="setTestWebhookMessage(test_webhook_message_elmt.value)"
          />
          <button
            class="custom-btn custom-btn-primary h-100"
            type="button"
            (click)="sendTestWebhookMessage()"
            [disabled]="test_webhook_message.length === 0"
          >
            SEND
          </button>
        </div>
        <div class="flex-grow-1 d-flex flex-column align-items-center justify-content-center mt-3" *ngIf="spinningTestMessage">
          SENDING THE MESSAGE TO WEBHOOK...
          <app-tiny-bot-spinner></app-tiny-bot-spinner>
        </div>
        <p *ngIf="!spinningTestMessage && !validWebhookMessage && testedWebhookMessage" class="mt-3 text-center info-text">
          <i class="fas fa-exclamation-circle text-warning"></i> There was an error with the webhook! Please try again!
        </p>
        <div *ngIf="!spinningTestMessage && validWebhookMessage && testedWebhookMessage" class="d-flex flex-column mt-3">
          <div *ngIf="testWebhookPrivateMessages.length || testWebhookPublicMessages.length || testWebhookReactions.length" class="mb-3 text-center">
            <div><span class="text-success mb-3 mr-2">✅ </span> Success!</div>
            <div>
              By using this webhook, <span class="text-success">one random reply</span> will be chosen from
              <span class="text-success">each of the list </span>below
            </div>
          </div>
          <div class="test-response-container">
            <div *ngIf="testWebhookReactions.length" class="test-response mb-2">
              <div class="text-center auto-reply-section-content-label">THE REACTION EMOJI THAT WILL BE SENT:</div>
              <div class="response-flex" *ngFor="let msg of testWebhookReactions; index as i">
                <div class="mr-2 text-or">
                  <div class="invisible" *ngIf="i === 0 && testWebhookReactions.length > 1">OR</div>
                  <div *ngIf="i > 0">OR</div>
                </div>
                <div class="text-message">
                  <img
                    class="edit-message-bloc-input-reactions-item no-transform mr-1"
                    src="/assets/img/fb-reactions/{{ msg }}.svg"
                    alt="{{ msg }}"
                  />
                  {{ msg }}
                </div>
              </div>
            </div>
            <div *ngIf="testWebhookPrivateMessages.length" class="test-response mb-2">
              <div class="auto-reply-section-content-label">THE PRIVATE MESSAGE THAT WILL BE SENT:</div>
              <div class="response-flex" *ngFor="let msg of testWebhookPrivateMessages; index as j">
                <div class="mr-2 text-or">
                  <div class="invisible" *ngIf="j === 0 && testWebhookPrivateMessages.length > 1">OR</div>
                  <div *ngIf="j > 0">OR</div>
                </div>
                <div class="text-message">{{ msg }}</div>
              </div>
            </div>
            <div *ngIf="testWebhookPublicMessages.length" class="test-response mb-2">
              <div class="auto-reply-section-content-label">THE PUBLIC MESSAGE THAT WILL BE SENT:</div>
              <div class="response-flex" *ngFor="let msg of testWebhookPublicMessages; index as k">
                <div class="mr-2 text-or">
                  <div class="invisible" *ngIf="k === 0 && testWebhookPublicMessages.length > 1">OR</div>
                  <div *ngIf="k > 0">OR</div>
                </div>
                <div class="text-message">{{ msg }}</div>
              </div>
            </div>
            <div
              class="mt-3 text-center info-text"
              *ngIf="!testWebhookPrivateMessages.length && !testWebhookPublicMessages.length && !testWebhookReactions.length"
            >
              <i class="fas fa-exclamation-circle text-warning"></i> No valid reply detected. Check the
              <a href="https://forum.ideta.io/t/how-to-use-webhooks-in-auto-comment-tool/178" target="_blank">documentation </a>
              to make sure the answer of your webhook is in the right format!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
